import React, { FocusEventHandler } from 'react';
import { noop } from 'lodash/fp';
import TextInput from '../../../../../common/components/TextInput';
import { REF_TOOLTIP_TEXT } from '../../constants/constants';
import messengerAdsRefHelpImage from 'assets/ads-ref-help-new.png';
import { QuestionCircleIcon } from '@mm/icons';
import classnames from 'classnames';

type Props = {
  text: string;
  usedInSlideout?: boolean;
};

export const RefTextInput = ({ text, usedInSlideout }: Props) => {
  const onRefFocus: FocusEventHandler<HTMLTextAreaElement> = e =>
    e.target.select();

  return (
    <div className="ad-detail__inputs-container">
      <div
        className={classnames('ad-detail__input-container', {
          'ad-detail__input-container-slideout': usedInSlideout,
        })}
      >
        <div className="ad-detail__field-title">URL Parameter</div>
        <div className="ad-detail__subtext-grey">
          {REF_TOOLTIP_TEXT}
          <QuestionCircleIcon
            color="var(--color-gray-8)"
            className="ad-detail__subtext-icon"
            onClick={() => window.open(messengerAdsRefHelpImage, '_blank')}
          />
        </div>
        <div className="ad-detail__text-input-container">
          <TextInput
            className="ad-detail__input"
            value={text}
            onFocus={onRefFocus}
            onChange={noop}
          />
        </div>
      </div>
    </div>
  );
};
